
export default {
    title: 'GJ监测系统',
    baseUrl: {
        dev: 'http://192.168.3.127:8089',
        pro: 'https://service.dy-gj.cn/'
    },
    uploadAction: '/api/admin/upload',
    imgServer: 'https://grouting-1318074248.cos.ap-nanjing.myqcloud.com',
}
